"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableActionCopy_1 = require("../../../../../../shared/components/table_actions/TableActionCopy");
var PromoCodeTypesList = /** @class */ (function (_super) {
    __extends(PromoCodeTypesList, _super);
    function PromoCodeTypesList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchTitleInput = null;
        _this.searchPrefixInput = null;
        _this.DESCRIPTION_FILTER = "PromoCodeTemplatesList-DescriptionFilter";
        _this.TITLE_FILTER = "PromoCodeTemplatesList-TitleFilter";
        _this.PREFIX_FILTER = "PromoCodeTemplatesList-PrefixFilter";
        return _this;
    }
    PromoCodeTypesList.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.DESCRIPTION_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.DESCRIPTION_FILTER);
        }
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.TITLE_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.TITLE_FILTER);
        }
        if (!this.props.state.getUIFilter().getUIFilterItemByKey(this.PREFIX_FILTER)) {
            this.props.state.getUIFilter().doUIRegisterFilterEmpty(this.PREFIX_FILTER);
        }
        this.setState({
            searchDescriptionFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.DESCRIPTION_FILTER).selectedValues,
            searchDescriptionValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.DESCRIPTION_FILTER).filterValue,
            isSearchDescription: this.props.state.getUIFilter().getUIFilterItemByKey(this.DESCRIPTION_FILTER).isFilterActive,
            searchTitleFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.TITLE_FILTER).selectedValues,
            searchTitleValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.TITLE_FILTER).filterValue,
            isSearchTitle: this.props.state.getUIFilter().getUIFilterItemByKey(this.TITLE_FILTER).isFilterActive,
            searchPrefixFilter: this.props.state.getUIFilter().getUIFilterItemByKey(this.PREFIX_FILTER).selectedValues,
            searchPrefixValue: this.props.state.getUIFilter().getUIFilterItemByKey(this.PREFIX_FILTER).filterValue,
            isSearchPrefix: this.props.state.getUIFilter().getUIFilterItemByKey(this.PREFIX_FILTER).isFilterActive
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                promo_type_filter: data.promo_type_filter,
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            promo_type_filter: this.props.data.getPromoCodeTypeFilter(),
            // currency_filter: this.props.data.getCurrencyFilter(),
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    PromoCodeTypesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PromoCodeTypesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    PromoCodeTypesList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0411\u043E\u043D\u0443\u0441 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PromoCodeTypesList.prototype.onClearDescriptionFilter = function () {
        var _this = this;
        this.setState({
            searchDescriptionFilter: [],
            searchDescriptionValue: ""
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.DESCRIPTION_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.DESCRIPTION_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.DESCRIPTION_FILTER, false);
        });
    };
    PromoCodeTypesList.prototype.onChangeDescriptionFilter = function (e) {
        var _this = this;
        this.setState({
            searchDescriptionValue: e.target.value
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.DESCRIPTION_FILTER, _this.state.searchDescriptionValue);
        });
    };
    PromoCodeTypesList.prototype.onConfirmDescriptionFilter = function () {
        var _this = this;
        this.setState({
            searchDescriptionFilter: [this.state.searchDescriptionValue]
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.DESCRIPTION_FILTER, [_this.state.searchDescriptionValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.DESCRIPTION_FILTER, true);
        });
    };
    PromoCodeTypesList.prototype.onClearTitleFilter = function () {
        var _this = this;
        this.setState({
            searchTitleFilter: [],
            searchTitleValue: ""
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.TITLE_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.TITLE_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.TITLE_FILTER, false);
        });
    };
    PromoCodeTypesList.prototype.onChangeTitleFilter = function (e) {
        var _this = this;
        this.setState({
            searchTitleValue: e.target.value
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.TITLE_FILTER, _this.state.searchTitleValue);
        });
    };
    PromoCodeTypesList.prototype.onConfirmTitleFilter = function () {
        var _this = this;
        this.setState({
            searchTitleFilter: [this.state.searchTitleValue]
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.TITLE_FILTER, [_this.state.searchTitleValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.TITLE_FILTER, true);
        });
    };
    PromoCodeTypesList.prototype.onClearPrefixFilter = function () {
        var _this = this;
        this.setState({
            searchPrefixFilter: [],
            searchPrefixValue: ""
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.PREFIX_FILTER, []);
            _this.props.state.getUIFilter().doUISetFilterValue(_this.PREFIX_FILTER, "");
            _this.props.state.getUIFilter().doUISetFilterActive(_this.PREFIX_FILTER, false);
        });
    };
    PromoCodeTypesList.prototype.onChangePrefixFilter = function (e) {
        var _this = this;
        this.setState({
            searchPrefixValue: e.target.value
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterValue(_this.PREFIX_FILTER, _this.state.searchPrefixValue);
        });
    };
    PromoCodeTypesList.prototype.onConfirmPrefixFilter = function () {
        var _this = this;
        this.setState({
            searchPrefixFilter: [this.state.searchPrefixValue]
        }, function () {
            _this.props.state.getUIFilter().doUISetFilterDataSelectedValues(_this.PREFIX_FILTER, [_this.state.searchPrefixValue]);
            _this.props.state.getUIFilter().doUISetFilterActive(_this.PREFIX_FILTER, true);
        });
    };
    PromoCodeTypesList.prototype.getIconTitle = function () {
        if (!this.state.isSearchTitle) {
            return "search";
        }
        else {
            return "close-circle";
        }
    };
    PromoCodeTypesList.prototype.getIconDescription = function () {
        if (!this.state.isSearchDescription) {
            return "search";
        }
        else {
            return "close-circle";
        }
    };
    PromoCodeTypesList.prototype.getIconPrefix = function () {
        if (!this.state.isSearchPrefix) {
            return "search";
        }
        else {
            return "close-circle";
        }
    };
    PromoCodeTypesList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _title_filter = this.state.searchTitleFilter;
        var _prefix_filter = this.state.searchPrefixFilter;
        return [{
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 180,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: _this.getIconTitle(), style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Брэнд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 150,
            }, {
                title: 'Префикс',
                dataIndex: this.props.data.dk_prefix,
                key: this.props.data.dk_prefix,
                width: 120,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchPrefixInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchPrefixValue, onChange: _this.onChangePrefixFilter.bind(_this), onPressEnter: function () { _this.onConfirmPrefixFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmPrefixFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearPrefixFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _prefix_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: _this.getIconPrefix(), style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.prefix.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchPrefixInput.focus();
                        });
                    }
                }
            }, {
                title: 'Тип',
                dataIndex: this.props.data.dk_template_type_title,
                key: this.props.data.dk_template_type_title,
                width: 120,
                filters: this.state.promo_type_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.promocode_template_type_title.includes(value); },
            }, {
                title: 'Истекает',
                dataIndex: this.props.data.dk_expire_day,
                key: this.props.data.dk_expire_day,
                width: 120,
                render: function (text, record, idx) {
                    if (!record.is_can_expire) {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                    else {
                        return (React.createElement("div", null,
                            record.expire_year,
                            "-",
                            record.expire_month,
                            "-",
                            record.expire_day));
                    }
                },
                align: "center"
            }, {
                title: 'Мультиактивация',
                dataIndex: this.props.data.dk_is_can_used_multiple_times,
                key: this.props.data.dk_is_can_used_multiple_times,
                width: 120,
                render: function (text, record, idx) {
                    if (!record.is_can_used_multiple_times) {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                    else {
                        return (React.createElement("div", null, "\u0414\u0410"));
                    }
                },
                align: "center"
            }, {
                title: 'Одноразовый',
                dataIndex: this.props.data.dk_is_disposable_codes,
                key: this.props.data.dk_is_disposable_codes,
                width: 120,
                render: function (text, record, idx) {
                    if (!record.is_disposable_codes) {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                    else {
                        return (React.createElement("div", null, "\u0414\u0410"));
                    }
                },
                align: "center"
            }, {
                title: 'Кол-во кодов',
                dataIndex: this.props.data.dk_promocodes_count,
                key: this.props.data.dk_promocodes_count,
                width: 120,
                align: "center"
            }, {
                title: 'Кол-во бонусов',
                dataIndex: this.props.data.dk_bonuses_count,
                key: this.props.data.dk_bonuses_count,
                width: 120,
                //filters: this.state.currency_filter,
                //filterMultiple: true,
                align: "center",
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать бонус", text: "Да" }, unlockedTexts: { menu: "Разблокировать бонус", text: "Нет" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 140,
                filters: [
                    { text: "Заблокирован", value: 'true' },
                    { text: "Разблокирован", value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_locked === (value === 'true'); }
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 220,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: _this.getIconDescription(), style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionCopy_1.default, { hint: "Клонировать", confirmText: "\u041A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onCloneData(record); } }))); },
                width: 120
            }];
    };
    ;
    PromoCodeTypesList.prototype.onCloneData = function (record) {
        var _this = this;
        this.props.dlgDescriptionEditor.SetTitle("Введите новый префикс").SetDescription(record.prefix).SetOnYesClick(function (description) {
            _this.props.data.DoClonePromoCodeTemplate(record.key, description, function () {
                _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }).Show();
    };
    PromoCodeTypesList.prototype.onConfigClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    PromoCodeTypesList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    PromoCodeTypesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u043E\u043D\u0443\u0441 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    PromoCodeTypesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PromoCodeTypesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    PromoCodeTypesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    PromoCodeTypesList.prototype.bool2Str = function (val) {
        if (val) {
            return "Да";
        }
        else {
            return "Нет";
        }
    };
    PromoCodeTypesList.prototype.GetIsNeedDeposit = function (record) {
        if (record.is_restrict_by_deposit_age) {
            return "\u0414\u0430. " + record.deposit_age_type_title;
        }
        else {
            return "Нет";
        }
    };
    PromoCodeTypesList.prototype.getActivateByDaysDescription = function (record) {
        var _ret = "";
        if (!record.is_allow_by_day_of_week_only) {
            return "Нет";
        }
        else {
            if (record.is_allow_on_monday) {
                _ret = "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A/";
            }
            if (record.is_allow_on_tuesday) {
                _ret = _ret + "\u0412\u0442\u043E\u0440\u043D\u0438\u043A/";
            }
            if (record.is_allow_on_wednesday) {
                _ret = _ret + "\u0421\u0440\u0435\u0434\u0430/";
            }
            if (record.is_allow_on_thursday) {
                _ret = _ret + "\u0427\u0435\u0442\u0432\u0435\u0440\u0433/";
            }
            if (record.is_allow_on_friday) {
                _ret = _ret + "\u041F\u044F\u0442\u043D\u0438\u0446\u0430/";
            }
            if (record.is_allow_on_saturday) {
                _ret = _ret + "\u0421\u0443\u0431\u0431\u043E\u0442\u0430/";
            }
            if (record.is_allow_on_sunday) {
                _ret = _ret + "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435";
            }
        }
        return _ret;
    };
    PromoCodeTypesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                        React.createElement("div", { style: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                flexWrap: "nowrap"
                            } },
                            React.createElement("div", null,
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                                    " [",
                                    record.key,
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                                    " [",
                                    record.date_added.format(_this.props.state.getDateTimeFormat()),
                                    "] "),
                                React.createElement("div", null,
                                    React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                                    " [",
                                    record.date_changed.format(_this.props.state.getDateTimeFormat()),
                                    "]")),
                            React.createElement("div", null,
                                React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: "" + _this.props.data.DATA.cdn_baseurl + record.cms_image_url })),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0412\u0441\u0435 \u0441\u0442\u0440\u0430\u043D\u044B \u0432 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 "),
                                " : [",
                                _this.bool2Str(record.is_all_country),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0434\u0435\u043D\u044C \u043D\u0435\u0434\u0435\u043B\u0438 "),
                                " : [",
                                _this.getActivateByDaysDescription(record),
                                "]"),
                            React.createElement("div", null,
                                React.createElement("b", null, "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C \u0434\u0435\u043F\u043E\u0437\u0438\u0442"),
                                " : [",
                                _this.GetIsNeedDeposit(record),
                                "]"))));
                }, scroll: { x: true } })));
    };
    return PromoCodeTypesList;
}(React.Component));
exports.default = PromoCodeTypesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ui/component/PromoCodeTemplatesList.tsx
// module id = 1959
// module chunks = 0